window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

window.o_global.eventQBus.on("assets.textExpander.init", (selector = "") => {
  // Sets up Events for pl_text-expander pattern
  const textExpanderToggleElements = document.querySelectorAll(
    ` ${selector} .js_pl_text-expander__link`
  );

  [].forEach.call(textExpanderToggleElements, (el) => {
    let hasMoreContentThanDisplayed = false;
    // add click handler
    el.addEventListener("click", (event) => {
      const { target } = event;
      const textExpander = window.o_util.dom.getParentByClassName(target, "pl_text-expander");
      let customEvent;
      let isOpen;

      if (textExpander) {
        textExpander.classList.toggle("pl_text-expander--expanded");
        isOpen = !!textExpander.classList.contains("pl_text-expander--expanded");

        customEvent = new CustomEvent("pl_text-expanderChange", {
          detail: {
            isOpen,
          },
          bubbles: true,
        });

        textExpander.dispatchEvent(customEvent);
        window.o_global.eventQBus.emit("assets.textExpander.toggled", {
          isOpen,
          target: customEvent.target,
        });
      }
    });
    const textExpander = window.o_util.dom.getParentByClassName(el, "pl_text-expander");
    const isOpen = !!textExpander.classList.contains("pl_text-expander--expanded");

    if (!isOpen) {
      const checkForMoreContentCSSClass = "pl_text-expander--check-has-more";

      // add css class that enables overflow and hides scroll bar
      // it thus enables us to check the actual content height via scrollHeight.
      textExpander.classList.add(checkForMoreContentCSSClass);

      // check if scrollHeight is higher than current height, indicating there is more content to display
      hasMoreContentThanDisplayed = textExpander.clientHeight < textExpander.scrollHeight;

      // remove the css class for checking again
      textExpander.classList.remove(checkForMoreContentCSSClass);

      if (hasMoreContentThanDisplayed) {
        textExpander.classList.add("pl_text-expander--has-more");
      } else {
        el.parentNode.style.display = "none";
      }
    }

    window.o_global.eventQBus.emit("assets.textExpander.initialised", {
      isOpen,
      hasMoreContentThanDisplayed,
      target: textExpander,
    });
  });
});

window.o_global.eventLoader.onReady(130, () => {
  window.o_global.eventQBus.emit("assets.textExpander.init", "body");
});
